export default function (container = document.body, returnArray = false) {
  const elements = [...container.querySelectorAll('*')];
  const property = 'dataset';
  return elements.reduce((res, el) => {
    [].slice.call(Object.entries(el[property])).forEach(([key]) => {
      if (key) {
        res[key] = Object.prototype.hasOwnProperty.call(res, key)
          ? res[key].constructor === Array
            ? res[key].concat(el)
            : [res[key], el]
          : returnArray
            ? [el]
            : el;
      }
    });
    return res;
  }, {});
}
